import { useStore, State } from 'store';

const selector = (state: State) => {
  return state.startWorkflow.steps.selectWorkflow.selectedWorkflowDefinition;
};

export default function useSelectedWorkflowDefinition() {
  return useStore(selector);
}
